import React, { useState } from "react";
import { BODY_ZONES, BodyView } from "../../config/bodyZones";

interface HumanBodyProps {
  selectedPart: string | null;
  onSelectPart: (part: string | null) => void;
}

const SHAPES = {
  legRight:
    "M185.898 657.733C184.103 645.333 185.045 624.038 188.306 607.583L229.383 593C238.688 619.017 237.506 637.338 214.226 706.374L185.495 712.694C190.594 699.992 187.031 665.262 185.898 657.733Z",
  footRight:
    "M178.57 753.117C178.57 753.117 183.459 718.981 186.127 712.32L214.858 706C214.858 706 207.751 721.296 211.318 748.779C211.318 748.779 226.215 779.379 216.653 779.992C216.653 779.992 215.874 782.019 212.687 780.414C212.687 780.414 207.541 785.726 201.993 782.845C201.993 782.845 196.844 786.951 192.427 783.295C192.427 783.295 188.864 787.355 183.719 784.074C183.719 784.074 176.964 788.533 173.021 783.694C173.021 783.694 165.833 785.276 178.57 753.117Z",
  kneeRight:
    "M188.378 608.145C190.662 596.338 184.315 574.101 182 560.453L231.533 530C228.133 542.02 230.165 572.291 227.377 579.817C226.171 583.078 226.834 586.051 229.455 593.562L188.378 608.145Z",
  pelvis:
    "M232.201 335.012C232.201 335.012 252.79 384.557 248.257 421.508L169.214 445.206C169.214 445.206 167.446 446.575 164.646 446.567L160.738 445.195L81.6551 421.496C77.107 384.545 97.7307 335 97.7307 335L232.201 335.012Z",
  thighRight:
    "M182.207 560.861C177.344 532.052 167.922 458.579 169.101 444.698L248.145 421C244.772 448.432 238.3 507.225 231.74 530.408L182.207 560.861Z",
  footLeft:
    "M117.533 748.779C121.154 721.296 113.989 706 113.989 706L142.743 712.32C145.423 719.024 150.285 753.118 150.285 753.118C162.979 785.276 155.849 783.695 155.849 783.695C151.836 788.631 145.081 784.075 145.081 784.075C139.936 787.355 136.408 783.295 136.408 783.295C132.007 786.956 126.858 782.846 126.858 782.846C121.298 785.726 116.153 780.414 116.153 780.414C112.931 782.02 112.186 779.992 112.186 779.992C102.659 779.379 117.533 748.779 117.533 748.779Z",
  legLeft:
    "M114.6 706.374C91.3206 637.342 90.1422 619.017 99.3974 593L140.547 607.583C143.758 624.019 144.7 645.263 142.944 657.733C141.854 665.193 138.244 699.996 143.355 712.694L115.556 708.872C114.997 707.22 114.6 706.374 114.6 706.374Z",
  kneeLeft:
    "M101.156 579.816C98.4036 572.26 100.435 541.996 97 530L146.591 560.453C144.242 574.124 137.879 596.365 140.228 608.144L99.0781 593.562C101.746 586.125 102.397 583.101 101.156 579.816Z",
  thighLeft:
    "M97.3857 530.408C90.8097 507.221 84.35 448.506 81 421L160.083 444.698C161.265 458.603 151.804 532.079 146.977 560.86L97.3857 530.408Z",
  handRight:
    "M279 403.795C279 403.795 280.058 392.082 280.058 387.243L301.783 369C303.551 373.711 309.643 381.644 314.365 387.569C323.621 399.197 339.417 423.469 330.988 426.16C330.988 426.16 324.474 426.796 315.831 409.654C315.831 409.654 316.044 416.265 322.961 435.342C324.26 438.932 330.041 457.063 320.693 450.498C320.693 450.498 316.397 447.528 310.732 428.874C310.732 428.874 313.757 460.277 310.449 461.855C306.083 464.003 303.648 457.795 301.667 430.313C301.667 430.313 299.631 421.437 298.689 455.314C298.643 457.063 296.022 465.775 292.458 458.338C289.48 452.103 290.83 435.574 290.83 430.053C290.83 430.053 286.91 451.464 283.343 451.464C283.343 451.464 279.116 456.469 280.838 429.863C281.074 425.54 279.613 416.595 279.423 413.997L279 403.795Z",
  armRight:
    "M243.879 287.635C243.879 287.635 244.232 262.278 235 247.912L236.206 126C236.206 126 268.624 126.318 273.111 170.314L273.677 234.814C273.677 234.814 276.084 273.018 288.88 293.498C288.88 293.498 296.363 306.646 297.235 336.917C297.235 336.917 299.411 362.569 302.292 370.549L280.567 388.792C280.567 387.609 276.391 371.673 265.364 354.877C265.364 354.877 242.414 314.23 243.879 287.635Z",
  handLeft:
    "M19.0238 387.569C23.7852 381.621 29.8726 373.688 31.6213 369L53.3694 387.243C53.3694 392.109 54.4318 403.795 54.4318 403.795L54.0208 413.997C53.8308 416.595 52.307 425.516 52.5901 429.863C54.3388 456.469 50.0775 451.464 50.0775 451.464C46.4561 451.464 42.5826 430.053 42.5826 430.053C42.5826 435.601 43.9397 452.103 40.9192 458.338C37.3404 465.775 34.7775 457.063 34.7309 455.314C33.7887 421.437 31.757 430.313 31.757 430.313C29.7757 457.795 27.3795 464.007 22.9864 461.855C19.6248 460.277 22.6452 428.874 22.6452 428.874C17.0153 447.524 12.6843 450.498 12.6843 450.498C3.33211 457.016 9.10549 438.885 10.4626 435.342C17.3681 416.218 17.5465 409.654 17.5465 409.654C8.93876 426.796 2.3899 426.16 2.3899 426.16C-6.00458 423.395 9.68711 399.174 19.0238 387.569Z",
  armLeft:
    "M60.181 170.314C64.5974 126.318 97.0702 126 97.0702 126L98.3149 247.912C89.0829 262.278 89.4008 287.635 89.4008 287.635C90.8781 314.211 67.9513 354.877 67.9513 354.877C56.928 371.673 52.7481 387.586 52.7481 388.792L31 370.549C33.8693 362.569 36.0522 336.917 36.0522 336.917C36.913 306.65 44.3614 293.498 44.3614 293.498C57.2071 273.018 59.5684 234.814 59.5684 234.814L60.181 170.314Z",
  abdomen:
    "M234.685 243.012C234.685 243.012 228.074 314.848 232.584 335.01L98.1132 334.998C102.553 314.832 96 243 96 243L234.685 243.012Z",
  chest:
    "M97.2446 247.912L96 126L237.136 126.012L235.93 247.924L97.2446 247.912Z",
  neck:
    "M196.487 121.713C196.487 121.713 197.423 123.886 201.493 126.716L125 126.708C129.072 123.876 130.006 121.702 130.006 121.702C135.128 114.33 134.309 101.97 133.529 96H192.965C192.184 101.965 191.361 114.337 196.487 121.713Z",
  head:
    "M201.2 71.5489C201.2 71.5489 198.978 83.9836 193.22 88.6675C193.22 88.6675 192.531 91.9927 192.23 96.5945H133.678C133.377 91.9867 132.687 88.6558 132.687 88.6558C126.925 83.9681 124.707 71.5373 124.707 71.5373C115.18 64.2052 115.591 53.4766 119.996 53.5929C123.571 53.6898 122.768 50.7508 122.768 50.7508C116.797 2.46608 159.692 2.28882e-05 159.692 2.28882e-05H166.237C166.237 2.28882e-05 209.113 2.46608 203.134 50.7624C203.134 50.7624 202.332 53.6976 205.876 53.6045C210.292 53.4882 210.761 64.2169 201.2 71.5489Z",
};

type ShapeName = keyof typeof SHAPES;

type ArmBands = { epaules?: string; bras: string; avantBras: string };
type ShapeZone = string | ArmBands;

const ELBOW_Y = 292;
const SHOULDER_Y = 170;

const FACE_MAP: Record<ShapeName, ShapeZone> = {
  head: "teteVisage",
  neck: "cou",
  chest: "thorax",
  abdomen: "abdomen",
  pelvis: "abdomen",
  armRight: { epaules: "epaules", bras: "brasGauche", avantBras: "avantBrasGauche" },
  armLeft: { epaules: "epaules", bras: "brasDroite", avantBras: "avantBrasDroit" },
  handRight: "mains",
  handLeft: "mains",
  thighRight: "cuisseGauche",
  thighLeft: "cuisseDroite",
  kneeRight: "jambeGauche",
  kneeLeft: "jambeDroite",
  legRight: "jambeGauche",
  legLeft: "jambeDroite",
  footRight: "pieds",
  footLeft: "pieds",
};

// Back view: the patient's right side is on the right of the image.
const DOS_MAP: Record<ShapeName, ShapeZone> = {
  head: "cuirCheveluNuque",
  neck: "cuirCheveluNuque",
  chest: "hautDuDos",
  abdomen: "basDuDos",
  pelvis: "fesses",
  armRight: { bras: "brasDroitDos", avantBras: "avantBrasDroitDos" },
  armLeft: { bras: "brasGaucheDos", avantBras: "avantBrasGaucheDos" },
  handRight: "mainsDos",
  handLeft: "mainsDos",
  thighRight: "arriereCuisseDroite",
  thighLeft: "arriereCuisseGauche",
  kneeRight: "molletDroit",
  kneeLeft: "molletGauche",
  legRight: "molletDroit",
  legLeft: "molletGauche",
  footRight: "plantesPieds",
  footLeft: "plantesPieds",
};

function HumanCard({ selectedPart, onSelectPart }: HumanBodyProps) {
  const [selectedPosition, setSelectedPosition] = useState<BodyView>("Face");

  const getColor = (part: string) =>
    selectedPart === part ? "#ef4444" : "#cbd5e1";

  const handlePartClick = (part: string | null) => {
    onSelectPart(part);
  };
  const handleReset = () => {
    setSelectedPosition("Face")
    onSelectPart(null)
  }

  const getButtonStyle = (partId: string) => {
    const isSelected = selectedPart === partId;
    const baseClasses = "px-2 py-2 text-sm font-medium rounded-lg shadow-md transition-colors duration-300 text-white w-full";
    const selectedClasses = "bg-red-600 hover:bg-red-700";
    const normalClasses = "bg-blue-600 hover:bg-blue-700";

    return `${baseClasses} ${isSelected ? selectedClasses : normalClasses}`;
  };

  const renderZone = (d: string, zone: string, key: string, clipId?: string) => (
    <path
      key={key}
      d={d}
      clipPath={clipId ? `url(#${clipId})` : undefined}
      fill={getColor(zone)}
      onClick={() => handlePartClick(zone)}
      style={{ cursor: "pointer" }}
    />
  );

  const renderShapes = (map: Record<ShapeName, ShapeZone>) =>
    (Object.keys(SHAPES) as ShapeName[]).map((name) => {
      const zone = map[name];
      if (typeof zone === "string") return renderZone(SHAPES[name], zone, name);
      return (
        <React.Fragment key={name}>
          {zone.epaules &&
            renderZone(SHAPES[name], zone.epaules, `${name}-epaules`, "humancard-clip-shoulder")}
          {renderZone(
            SHAPES[name],
            zone.bras,
            `${name}-bras`,
            zone.epaules ? "humancard-clip-arm" : "humancard-clip-upper-arm"
          )}
          {renderZone(SHAPES[name], zone.avantBras, `${name}-avantBras`, "humancard-clip-forearm")}
        </React.Fragment>
      );
    });

  return (
    <div className="flex flex-col items-center w-full max-w-6xl mx-auto p-4">
      {/* Toggle Face / Dos */}
      <div className="inline-flex justify-center items-center bg-gray-200 rounded-xl p-1 mb-8">
        <button
          type="button"
          className={`px-6 py-2 font-medium transition-all duration-300 rounded-lg ${
            selectedPosition === "Face"
              ? "bg-blue-600 text-white shadow-md"
              : "bg-transparent text-blue-600 hover:bg-blue-100"
          }`}
          onClick={() => setSelectedPosition("Face")}
        >
          Face
        </button>

        <button
          type="button"
          className={`px-6 py-2 font-medium transition-all duration-300 rounded-lg ${
            selectedPosition === "Dos"
              ? "bg-blue-600 text-white shadow-md"
              : "bg-transparent text-blue-600 hover:bg-blue-100"
          }`}
          onClick={() => setSelectedPosition("Dos")}
        >
          Dos
        </button>
      </div>
    <div className="flex flex-col md:flex-row gap-4 lg:gap-12 justify-center items-start w-full ">

      {/* SVG Body */}
      <div className="w-full max-w-[300px] lg:max-w-[350px] mx-auto flex justify-center">
        <svg width="200" height="700" viewBox="0 0 334 786">
          <defs>
            <clipPath id="humancard-clip-shoulder">
              <rect x="0" y="0" width="334" height={SHOULDER_Y} />
            </clipPath>
            <clipPath id="humancard-clip-arm">
              <rect x="0" y={SHOULDER_Y} width="334" height={ELBOW_Y - SHOULDER_Y} />
            </clipPath>
            <clipPath id="humancard-clip-upper-arm">
              <rect x="0" y="0" width="334" height={ELBOW_Y} />
            </clipPath>
            <clipPath id="humancard-clip-forearm">
              <rect x="0" y={ELBOW_Y} width="334" height={786 - ELBOW_Y} />
            </clipPath>
          </defs>
          {renderShapes(selectedPosition === "Face" ? FACE_MAP : DOS_MAP)}
          {selectedPosition === "Dos" && (
            <path
              d="M119 438.724C134.131 448.678 164.628 446.931 164.628 432C163.677 451.082 206.95 451.082 214.09 436.564"
              stroke="white"
              strokeWidth={1.33333}
              fill="none"
            />
          )}
        </svg>
      </div>
      <div className="w-full max-w-[500px] flex flex-col gap-6">
      <div className="mb-6 flex flex-col items-center">
        <button type="button"
          className="self-center px-8 py-2 bg-gray-600 text-white font-bold rounded-lg shadow hover:bg-gray-700 transition-colors uppercase tracking-wider"
          onClick={handleReset}
        >
            Réinitialiser
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3 w-full p-2">
        {BODY_ZONES[selectedPosition].map((zone) => (
          <button
            key={zone.key}
            type="button"
            className={getButtonStyle(zone.key)}
            onClick={() => handlePartClick(zone.key)}
          >
            <span>{zone.label}</span>
          </button>
        ))}
      </div>
      </div>
    </div>
    </div>
  );
}

export default React.memo(HumanCard);
